import { SravniNewsSharedEnumsMaterialType } from '../__generated__/news/Api';
import { NEWS_TYPES } from '../constants/news';
import { IMaterial } from '../interfaces/news';

export const checkIsArticle = (material: IMaterial): boolean =>
  material.type === SravniNewsSharedEnumsMaterialType.Article;
export const checkIsNews = (material: IMaterial): boolean => NEWS_TYPES.includes(material.type);
export const checkIsPartnerNews = (material: IMaterial): boolean => material.rubric === 'novosti-partnerov';
